export default "__VITE_ASSET__BhLM3yJ___"